import {
  GETKYCAPPROVEREJECT_SUCCESS,
  GETKYCAPPROVEREJECT_FAILED,
  RESET_GETKYCAPPROVEREJECT,
  LOADING_GETKYCAPPROVEREJECT,
  NETWORK_ERROR_GETKYCAPPROVEREJECT,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETKYCAPPROVEREJECT:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETKYCAPPROVEREJECT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETKYCAPPROVEREJECT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETKYCAPPROVEREJECT:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETKYCAPPROVEREJECT:
      return (state = initialState);
    default:
      return state;
  }
};
